import { useEffect, useState } from 'react';

export default function LoadingScreen({ onDone }) {
  const [phase, setPhase] = useState('enter'); // enter | exit

  useEffect(() => {
    const t1 = setTimeout(() => setPhase('exit'), 2200);
    const t2 = setTimeout(() => onDone(), 2900);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-cream overflow-hidden transition-opacity duration-700 ${phase === 'exit' ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}
    >
      <div className="loader-circle" />
      <div className="relative z-10 text-center">
        <h1
          className="loader-text font-playfair text-6xl font-light tracking-[0.3em] text-white"
          style={{ letterSpacing: '0.3em' }}
        >
          AURA
        </h1>
        <p className="loader-text mt-2 font-dm text-xs tracking-[0.4em] text-white/70 uppercase" style={{ animationDelay: '0.6s' }}>
          wellness studio
        </p>
      </div>
    </div>
  );
}
